import { inject, Injectable } from '@angular/core';
import _ from 'lodash';
import { map, Observable } from 'rxjs';

import { Permissions } from '../constants/permissions';
import { AccessControlFacade } from '../state/access-control.facade';

@Injectable()
export class PermissionsFacade {
    private readonly accessControlFacade = inject(AccessControlFacade);

    hasPermission(permission: Permissions): Observable<boolean> {
        return this.accessControlFacade.permissions$.pipe(
            map((permissions) => permissions.includes(permission as Permissions))
        );
    }

    hasPermissions(permission: Permissions[]): Observable<boolean> {
        return this.accessControlFacade.permissions$.pipe(
            map(
                (targetPermissions) =>
                    !_.isEmpty(permission) && _.every(permission, (el) => _.includes(targetPermissions, el))
            )
        );
    }
}
